// extracted by mini-css-extract-plugin
module.exports = {"pieChartWrapper":"styles_pieChartWrapper__3YWr5","legendWrapper":"styles_legendWrapper__hga43"};